import type { SerializableDynamicValue } from "~/Configurators/common/v2/types";

export const ImperialShaftDefaultValues: Record<string, SerializableDynamicValue<string>> = {
  VWST_078: "CF53",
  VBSCH_078: "/",
  VLMAX_01A_078: "LN",
  VBEAL_078: "005",
  VBEAM_078: "980",
  VBEAR_078: "005",
};
